import gql from 'graphql-tag'

export const channelAcknowledgementFragment = gql`
  fragment channelAcknowledgementAttrs on ChannelActivityAknowledgment {
    __typename
    entityId
    aknowledgedAt
  }
`

export const noteAcknowledgementFragment = gql`
  fragment noteAcknowledgementAttrs on NoteActivityAknowledgment {
    __typename
    entityId
    aknowledgedAt
    version
  }
`

export const threadAknowledgementFragment = gql`
  fragment threadAknowledgementAttrs on ThreadActivityAknowledgment {
    __typename
    entityId
    noteId
    aknowledgedAt
  }
`

export const aknowledgeChannelActivity = gql`
  mutation aknowledgeChannelActivity($channelId: ID!) {
    aknowledgeChannelActivity(channelId: $channelId) {
      ...channelAcknowledgementAttrs
    }
  }
  ${channelAcknowledgementFragment}
`

export const aknowledgeNoteActivity = gql`
  mutation aknowledgeNoteActivity($noteId: ID!, $version: Int!) {
    aknowledgeNoteActivity(noteId: $noteId, version: $version) {
      ...noteAcknowledgementAttrs
    }
  }
  ${noteAcknowledgementFragment}
`

export const aknowledgeThreadsActivity = gql`
  mutation aknowledgeThreadsActivity($noteId: ID!, $threadIds: [ID!]!) {
    aknowledgeThreadsActivity(noteId: $noteId, threadIds: $threadIds) {
      ...threadAknowledgementAttrs
    }
  }
  ${threadAknowledgementFragment}
`

export const channelActivityAknowledged = gql`
  subscription channelActivityAknowledged {
    channelActivityAknowledged {
      ...channelAcknowledgementAttrs
    }
  }
  ${channelAcknowledgementFragment}
`

export const noteActivityAknowledged = gql`
  subscription noteActivityAknowledged {
    noteActivityAknowledged {
      ...noteAcknowledgementAttrs
    }
  }
  ${noteAcknowledgementFragment}
`

export const threadActivitiesAknowledged = gql`
  subscription threadActivitiesAknowledged {
    threadActivitiesAknowledged {
      ...threadAknowledgementAttrs
    }
  }
  ${threadAknowledgementFragment}
`
